"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _notification = _interopRequireDefault(require("britive-design-system/core/components/notification"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationContainer = function NotificationContainer(_ref) {
  var type = _ref.type,
      duration = _ref.duration,
      open = _ref.open,
      title = _ref.title,
      closeNotification = _ref.closeNotification,
      outside = _ref.outside;

  var closeHandler = function closeHandler() {
    closeNotification();
  };

  return open && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      margin: outside ? '-144px 0 144px' : '0'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'absolute',
      zIndex: 9999
    }
  }, /*#__PURE__*/_react.default.createElement(_notification.default, {
    type: type,
    title: title,
    duration: duration,
    open: open,
    onClose: closeHandler
  })));
};

NotificationContainer.propTypes = {
  title: _propTypes.default.string,
  type: _propTypes.default.oneOf(['general', 'success', 'error', 'warning']),
  duration: _propTypes.default.number,
  closeNotification: _propTypes.default.func.isRequired,
  open: _propTypes.default.bool.isRequired,
  outside: _propTypes.default.bool
};
var _default = NotificationContainer;
exports.default = _default;